module.exports = __webpack_public_path__ + "img/bj.486f3805.jpg";